import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Field } from '../fields.component';
import { OrderValidator } from 'src/app/shared/order';
import { Store } from '@ngrx/store';
import { appState } from 'src/app/shared/interfaces/appState.interface';
import { FilterByObjectPipe } from 'src/app/shared/pipes/filter/filter-by-object';
import { typeProposal } from '@shared-logic/subjects/constants/proposal-type';

@Component({
  selector: 'app-type-proposal',
  templateUrl: './type-proposal.component.html',
  styleUrls: ['./type-proposal.component.scss'],
})
export class TypeProposalComponent extends Field implements OnInit {
  //List of proposal types that we use to display the select
  public proposalTypes = typeProposal;
  public arrayProposalTypes: any[] = [];

  constructor(store: Store<appState>, private orderV: OrderValidator) {
    super(store);
    this.pipe = new FilterByObjectPipe();
  }

  ngOnInit(): void {
    // Initialize array of proposal types, removing invalid values (-1, 0)
    this.arrayProposalTypes = this.getArrayOf(typeProposal);

    // Set tags for NgRx path: order.sellerData.proposalType
    this.tag = 'sellerData';
    this.subTag = 'proposalType';
    this.thirdTag = '';

    // Set identifier for click detection
    this.setIdentifyClassName();
  }

  /**
   * Given an object dictionary, returns an array of keys excluding -1 and 0
   */
  getArrayOf(object: any): any[] {
    try {
      let copy = JSON.parse(JSON.stringify(object));
      delete copy['-1'];
      delete copy[0];
      return Object.keys(copy);
    } catch (error) { }
    return [];
  }

  /**
   * Remember the value from the store when the component loads or updates
   */
  override rememberValueInForm() {
    this.rememberValueWithObject();
  }

  /**
   * Get proposal type selected and return the value for display
   */
  getProposalTypeSelected() {
    const proposalType = this.orderV.getProposalType(this.elementToGenerate);
    return proposalType == '--' ? '' : proposalType;
  }

  /**
   * Handle value selection from select-input
   */
  setValueWithEvent(event: any) {
    this.setElement(event.element, event.index);
    console.log('event', event);
  }
}
